import IconComponent from 'gcs-common/components/Icon/Icon';
import { ICON, ICON_COLOR } from 'gcs-common/constants/IconConstants';
import { getErrorMsg } from 'gcs-common/helper/errorMessages';
import { getMediaFileSizeLimit } from 'gcs-common/helper/fileHelper';
import { getSelectedChannelId } from 'gcs-common/slices/channels/channelsSelectors';
import {
  getChannelInputIsSendingFiles,
  getChannelInputStagedFiles,
} from 'gcs-common/slices/messageInput/messageInputSelector';
import { channelInputFileStaged } from 'gcs-common/slices/messageInput/messageInputSlice';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showFailureNotification } from '../../../slices/notifications/ShowNotificationThunk';
import FileInputButton from '../../FileInputWrapper/FileInputWrapper';
import styles from './styles.module.scss';

const MessageInputFileButton = () => {
  const selectedChannelId = useSelector(getSelectedChannelId);
  const isSendingFiles = useSelector(getChannelInputIsSendingFiles(selectedChannelId));
  const files = useSelector(getChannelInputStagedFiles(selectedChannelId));
  const dispatch = useDispatch();

  const onFileInputChanged = useCallback(
    (inputFiles) => {
      for (const file of inputFiles) {
        const fileSizeLimit = getMediaFileSizeLimit(file);
        if (file.size > fileSizeLimit) {
          const errorMessage = getErrorMsg('files.wrongFileSize', file.name, fileSizeLimit / 1000000);
          dispatch(showFailureNotification(errorMessage));
        } else {
          dispatch(channelInputFileStaged({ channelId: selectedChannelId, file }));
        }
      }
    },
    [dispatch, selectedChannelId],
  );

  return (
    <FileInputButton
      className={styles.fileInputButton}
      onChange={onFileInputChanged}
      disabled={isSendingFiles}
      value={files}
      title="Datei hochladen"
    >
      <IconComponent Icon={ICON.PLUS} color={ICON_COLOR.LIGHT_GREY} alt="Datei hochladen" />
    </FileInputButton>
  );
};

export default MessageInputFileButton;
